import React, { Component } from "react";

const bdcUserContext = React.createContext();

export class BDCAuthProvider extends Component {
  state = {
    isBDCUser: false,
    isClient: false,
    isPGMUser: false,
  };

  /* *** for BDC user loggedin *** */
  senseBDCUSer = () => {
    this.setState({ isBDCUser: true });
  };

  unSenseBDCUser = () => {
    this.setState({ isBDCUser: false });
  };

  sensePGMUser = () => {
    this.setState({ isPGMUser: true });
  };

  unSensePGMUser = () => {
    this.setState({ isPGMUser: false });
  };

  senseClient = () => {
    this.setState({ isClient: true });
  };
  unSenseClient = () => {
    this.setState({ isClient: false });
  };

  render() {
    const { isBDCUser, isClient, isPGMUser } = this.state;
    const {
      senseBDCUSer,
      unSenseBDCUser,
      sensePGMUser,
      unSensePGMUser,
      senseClient,
      unSenseClient,
    } = this;
    return (
      <bdcUserContext.Provider
        value={{
          isBDCUser,
          senseBDCUSer,
          unSenseBDCUser,
          isPGMUser,
          sensePGMUser,
          unSensePGMUser,
          isClient,
          senseClient,
          unSenseClient,
        }}
      >
        {this.props.children}
      </bdcUserContext.Provider>
    );
  }
}

export default bdcUserContext;
